function formatPrice(x) {
  return Number.parseFloat(x).toFixed(2);
}

export { formatPrice };



// WEBPACK FOOTER //
// ./src/helpers.js